module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/website_ui-dc569fcb262056925a7c3112b23f3af2.webp";